import api from '@/api/_cca-mobile';
import constantesApi from '@/api/_constantes-dossier';
import infirmierApi from '@/api/_infirmier';
import { showToast } from '@/utils/notifications';
import ManageConstante from '@/views/consultations/en-cours/constantes/manage-constante';
import FeuilleSurveillanceConstantes from '@/components/feuille-surveillance-constantes';
import $ from 'jquery';

export default {
    name: 'constantes',
    components: {
        ManageConstante,
        FeuilleSurveillanceConstantes
    },
    props: {
        consultation: Object,
        section_name: String,
        evolution_id: Number,
        evolution_toggler: Number,
        current_consultation_evolution: Number,
        is_start: Number,
        user_info: Object,
        mode_infirmier: { type: Boolean, default: false },
    },
    data() {
        return {
            is_loading: true,
            is_empty: false,
            modal_toggler: 0,
            selected_constant: {},
            data_to_be_deleted: {},
            info_user: {},
            selectedConstante: undefined,
            isSharingConstante: false,
            groupes_constantes: [],
            catalogue_constantes: null,
            erreur_constantes: '',
            constantes_sequence: 0,
            prise_infirmiere_autorisee: false,
            feuille_visible: false,
        };
    },

    watch: {
        evolution_toggler() {
            this.refreshConstantes()
            this.userInfoSetter()
        },
        'consultation.id'() { this.refreshConstantes() }
    },

    computed: {
        mode_sage_femme() {
            const role = this.$store && this.$store.getters.activeRole
            return !this.mode_infirmier && role && role.nom === 'ROLE_SAGE_FEMME'
        },
        serviceConstantes() { return this.mode_sage_femme ? constantesApi.sageFemme : constantesApi },
        peut_ajouter() {
            const fermee = Number(this.consultation.is_end) === 1
            const complement = !this.mode_infirmier && this.consultation.complement && this.consultation.complement.jusqu_au
            if ((fermee && !complement) || Number(this.current_consultation_evolution) !== Number(this.evolution_id)) return false
            return this.mode_infirmier
                ? this.prise_infirmiere_autorisee && !this.is_loading && !this.erreur_constantes
                : Number(this.is_start) === 1
        },
        consultation_constantes() {
            return this.groupes_constantes;
        },

        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        evolution_id_initiale() {
            return this.$store.getters['evolution_id_initiale']
        },

        selected_consultation_encours() {
            return this.$store.getters['selected_consultation_encours']
        },
    },

    async mounted() {
        this.refreshConstantes()
    },
    beforeDestroy() { this.constantes_sequence++ },

    methods: {
        constantesEnregistrees() {
            this.refreshConstantes()
            this.$emit('mesures-enregistrees')
        },
        uniteComplementaire(champ) {
            const code = champ.contenu && champ.contenu[0] && champ.contenu[0].unite
            const field = this.catalogue_constantes && this.catalogue_constantes.fields.find(item => item.key === 'champ:' + champ.champ_id)
            const unit = field && (field.units || []).find(item => item.code === code)
            return unit && unit.label || code || ''
        },
        userInfoSetter() {
            this.info_user = {
                nom_medecin: this.user_info.user,
                titre: this.user_info.titre
            }
        },

        async refreshConstantes() {
            this.is_loading = true
            const sequence = ++this.constantes_sequence, id = this.consultation.id
            this.groupes_constantes = []; this.catalogue_constantes = null; this.erreur_constantes = ''; this.is_empty = false
            this.prise_infirmiere_autorisee = false
            try {
                const credential = await (this.mode_infirmier ? infirmierApi.getTableauInfirmierAccess() : this.serviceConstantes.getConstantesAccess())
                if (sequence !== this.constantes_sequence) return
                if (!credential.success || !credential.data || !credential.data.access_token) throw new Error('Accès indisponible')
                const response = await (this.mode_infirmier
                    ? infirmierApi.lireConstantes({consultation_id:id,access_token:credential.data.access_token})
                    : this.serviceConstantes.lireConstantes({consultation_id:id,evolution_id:this.evolution_id,access_token:credential.data.access_token}))
                if (sequence !== this.constantes_sequence) return
                if (!response.consultation || Number(response.consultation.id) !== Number(id) || !Array.isArray(response.data)) throw new Error('Réponse inattendue')
                this.groupes_constantes = this.mode_infirmier ? response.data.filter(group => Number(group.evolution_id) === Number(this.evolution_id)) : response.data
                this.catalogue_constantes = response.catalogue || null; this.is_empty = this.groupes_constantes.length === 0
                this.prise_infirmiere_autorisee = response.can_save === true
            } catch (error) {
                if (sequence === this.constantes_sequence) this.erreur_constantes = 'Impossible de charger les constantes. Vérifiez votre accès puis réessayez.'
            } finally { if (sequence === this.constantes_sequence) this.is_loading = false }
        },

        addConstante() {
            if (this.mode_infirmier) {
                if (this.peut_ajouter) this.$emit('nouvelle-prise')
                return
            }
            this.modal_toggler = (this.modal_toggler === 0) ? 1 : 0

            this.selected_constant = {
                constante_group_id: 0
            }
        },

        editConstant(cste) {
            this.modal_toggler = (this.modal_toggler === 0) ? 1 : 0
            this.selected_constant = cste
        },

        removeGroupConstante(constante) {
            this.data_to_be_deleted = {
                data_type: 'constante',
                libelle: constante.reference,
                consultation_id: this.consultation.id,
                evolution_id: this.evolution_id,
                user_id: this.user_info.id,
                group_id: constante.constante_group_id
            }
        },

        async handleConfirmSharing() {
            this.isSharingConstante = true;

            try {
                const response = await api.shareConstante(this.selectedConstante.reference);

                if (response && response.status === 200) {
                    showToast("Constantes(s) partagée(s) avec succès")
                }
            } catch (error) {
                if (error.response) {
                    if (error.response.status === 400 || error.response.status === 422) {
                        showToast("Erreur de requête", 'error')
                    } else if (error.response.status === 500) {
                        showToast("Une erreur s'est produitre, veuillez réessayer plustard", 'error')
                    }
                }
            } finally {
                this.isSharingConstante = false;

                $('.modal').modal('hide');
            }
        }
    }
}
